import * as KibanaConfigActions from './action';
const initialState = {
    kibanaconfigSuccess: null,
    kibanaconfigFailure: null
}
const FetchKibanaConfigReducer = (state = initialState, action) => {
    switch (action.type) {
        case KibanaConfigActions.FETCH_KIBANA_CONFIG_SUCCESS:
            return state = {
                ...state,
                kibanaconfigSuccess: action.data
            }
        case KibanaConfigActions.FETCH_KIBANA_CONFIG_FAILURE:
            return state = {
                ...state,
                kibanaconfigFailure: action.data
            }

        default: return state;
    }
};

export default FetchKibanaConfigReducer; 